import React from 'react';
import Nav from '../Page Components/Nav';
import Footer from "../Page Components/Footer";
import Card from "../Co Components/SquareCards";
import Square from "../Co Components/SquareCards";
import Vision from "../assets/Images/about/target icon.png";
import headerImage from "../assets/Images/about/A_U.png";
import Mission from "../assets/Images/about/lamp icon.png";
import Title from "../Co Components/Titles";
import PrimaryButton from "../Co Components/PrimaryButton";
import SecondaryButton from "../Co Components/SecondaryButton";
import HomeCard from "../Co Components/HomeCards";
import screen from "../assets/Images/whitehawk/iPad Mockup.png";
import hashtag from "../assets/Images/whitehawk/hashtag.png";
import { useEffect } from 'react';
import {Col} from "react-bootstrap";


const About = () => {
    useEffect(() => {
        window.scrollTo(0, 0)


    });
    const fontColor = {color:'#FBF3E4'}

    return (
        <>

            <Nav />
            {/*<section className={' d-flex flex-col flex-wrap mt-12 justify-content-lg-center'}>*/}
            {/*    <article className={''}>*/}
            {/*        <div className={''}>*/}
            {/*            <center> <h1 className={'text-black  w-50 line-normal-2'}>*/}
            {/*                <span className={'green'}>Simplifying</span> Security,<br />*/}
            {/*                So You <span className={'red'}>Don't</span> Have To.*/}
            {/*            </h1>*/}
            {/*                <p className={'fs-6 Poppins  w-75'}>*/}
            {/*                    "The only truly secure system is one that is powered off, cast in a block of concrete,*/}
            {/*                    and sealed in a lead-lined room with armed <strong>guards.</strong>" - Gene Spafford*/}
            {/*                </p>*/}

            {/*            </center>*/}
            {/*        </div>*/}
            {/*    </article>*/}
            {/*</section>*/}
            <div className={'d-flex bg-black flex-row flex-wrap justify-content-evenly'}>
                <Col xl={5} lg={5} md={12} sm={12} className={'pt-3 pb-3'}>
                    <h1 style={fontColor} className={' display-2 bolder  '}  >About Us</h1>
                    <h4 style={fontColor}><span style={{color:'#EFC262'}}>The WHITEGUARD</span> is a leading global company,
                        specializing in Cybersecurity,
                        Cloud Computing & Network Security with a wide range of services & products,
                         serving companies in different countries
                        and providing services across many verticals including
                        banking, insurance, hi-tech, automotive, energy, communication, critical  infrastructures,
                        healthcare, and international mega-brands.</h4>
                </Col>
                <Col xl={4} lg={4}>
                    <div className={'pt-5 pb-5   d-none d-lg-block'} >
                        <img style={{boxShadow: '0 3px 15px rgba(255, 255, 251, 0.85)',width:"400px"}} src={headerImage}/>
                    </div>
                </Col>
            </div>



            {/*<div className="container-test">*/}

            {/*    <div className="rightDiv">*/}
            {/*        <p className={'text-black text-center  fs-5'}>*/}
            {/*                The WHITEGUARD hopes to empower*/}
            {/*                our customers to achieve and*/}
            {/*                maintain information security through*/}
            {/*                hiring the best Information Security*/}
            {/*                professionals and providing high-*/}
            {/*                quality professional Security services*/}
            {/*                and security products.*/}
            {/*            </p>*/}
            {/*    </div>*/}
            {/*    <div className="leftDiv">*/}
            {/*        <p className={'text-black text-center  fs-5'}>*/}
            {/*                The WHITEGUARD hopes to empower*/}
            {/*                our customers to achieve and*/}
            {/*                maintain information security through*/}
            {/*                hiring the best Information Security*/}
            {/*                professionals and providing high-*/}
            {/*                quality professional Security services*/}
            {/*                and security products.*/}
            {/*            </p>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className={'position-absolute missionImage'}>
                <img src={Vision} className={'MVImagetag'}/>
            </div>
            <div className="container-mission mt-7">
                <div className="contentDiv">
                    <h1 className={'header'}>Mission</h1>
                    <p className={'paragraph bold'}><span className={'bolder'}>The WHITEGUARD</span> hopes to empower our customers to achieve and maintain information
                         security through hiring the best information security professionals and providing high-quality
                         professional security services and security products.
                    </p>
                </div>
                <div className="imageDiv">
                    <h1 className={'text-white display-3 bolder'}>
                        Mission
                    </h1>
                </div>
            </div>

            <div className="container-vision mt-7">

                <div className="contentDiv">
                    <h1 className={'header'}>Vision</h1>
                    <p className={'paragraph bold'}><span className={'bolder'}>The WHITEGUARD</span> aims to become
recognized as a market leader in
delivering the world’s class information
security services and solutions across the
regions.
                    </p>
                </div>
                <div className="imageDiv visionBackground">
                    <h1 className={'text-white display-3 bolder'}>
                        Vision
                    </h1>
                </div>
            </div>
            <div className={'position-absolute visionImage'}>
                <img src={Mission} class={'MVImagetag'}/>
            </div>


            <Footer />
        </>
    );

}

export default About;